const canvas = {
  showGrid: "Show Grid",
  snapToGrid: "Snap to Grid",
  zoom: "Zoom",
  addField: "Add Field",
  placedBy: "Placed by",
  placedAt: "Placed at",
  lastMoved: "Last moved",
  usedInDocuments: "Used in documents",
  fieldGraph: "Field Graph",
  editorZone: "Editor Zone",
  resetLayout: "Reset Layout",
  documents: "Documents",
  fields: "Fields",
  documentTitle: "Document title",
  saving: "Saving...",
  saved: "✓ Saved",
  retrying: "Retrying...",
  saveError: "⚠ Save error",
  conflict: "⚠ Conflict",
  offline: "☁ Offline — saved locally",
  editorWidth: "Editor Width",
  widthNarrow: "Narrow",
  widthMedium: "Medium",
  widthWide: "Wide",
  widthFull: "Full",
} as const;
export default canvas;
